import { useRouter } from "next/router"
import { FRAGMENT_TYPES } from "@/constants"
import { useEffect } from "react"

const ContainerComponent = ({ children, extraProps, item, count }) => {
  const isTargetModule = item?.contentType === "target"
  const router = useRouter()
  useEffect(() => {
    const timeOut = setTimeout(() => {
      let hashValue = router?.asPath?.split("#")[1] ?? ""
      if (!hashValue) return

      // Decode hash for consistency with other components
      try {
        hashValue = decodeURIComponent(hashValue)
      } catch (error) {
        // fallback to raw hashValue if decoding fails
      }

      if (window.__gbhContainerHashScrollHandled === hashValue) return

      const element = document.getElementById(hashValue)
      if (!element) return

      if (
        element?.classList?.contains("cmp-tabs__tab") ||
        element?.closest(".cmp-tabs")
      ) {
        return
      }

      // Use getBoundingClientRect for reliable offset
      const rect = element?.getBoundingClientRect()
      const offsetTop = rect ? rect.top + window.scrollY : undefined
      if (typeof offsetTop !== "number") return

      window.__gbhContainerHashScrollHandled = hashValue
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      })
    }, 1000)
    return () => {
      clearTimeout(timeOut)
    }
  }, [])
  return (
    <div
      className={`cmp-container${
        extraProps?.fragment === FRAGMENT_TYPES.HEADER &&
        extraProps?.hasGlobalNavigation &&
        count === 0
          ? " desk-header-height"
          : ""
      }${isTargetModule ? " hidden" : ""}`}
      id={item?.customId || item?.containerId}
    >
      {children}
    </div>
  )
}

export default ContainerComponent
